import React, { Component } from "react";
import { Field } from "redux-form";
import normalizePhone from '../../lib/normalizephone'
const divStyle = {
    backgroundColor:'#fff'
};
const padStyle = {
    paddingTop:'5px'
};
class Borrower extends Component {

    renderInput = ({ input, label, meta }) => {
        const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
        const feedbackMessage = `${meta.error && meta.touched ? 'Borrower last name is required' : ''} `;
        return (
            <div className="form-group">
                <input {...input} autoComplete="new-password" className={className} placeholder={label} />
                <div className="invalid-feedback">{meta.error}</div>
            </div>
            );
    };

    render() {
        return (
            <>
                <div className="form-row col-12 pl-0" style={padStyle}>
                    <div className="col-4" style={divStyle}>
                        <Field name={`${this.props.prefix}FirstName`} component={this.renderInput} label="First Name" />
                    </div>
                    <div className="col-4">
                        <Field name={`${this.props.prefix}MiddleName`} component={this.renderInput} label="Middle Name" />
                    </div>
                    <div className="col-4" style={divStyle}>
                        <Field name={`${this.props.prefix}LastName`} component={this.renderInput} label="Last Name" />
                    </div>
                </div>
                <div className="form-row col-12 pl-0">
                    <div className="col-4" style={divStyle}>
                        <Field name={`${this.props.prefix}Email`} component={this.renderInput} label="Email" />
                    </div>
                    <div className="col-4" style={divStyle}>
                        <Field name={`${this.props.prefix}Phone`} component={this.renderInput} label="Phone" normalize={normalizePhone}/>
                    </div>
                </div>
            </>
            );
    };
};
export default Borrower;
